import { useState, useEffect } from 'react';
import ConsultingFormModal from '../../../components/ConsultingFormModal';

export default function Services() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const services = [
    {
      title: "위험성평가",
      description: "사업장 내 유해·위험요인을 파악하고 개선대책을 수립하여 산업재해를 예방합니다.",
      image: "https://public.readdy.ai/ai/img_res/f52378af9810876bb4c8d4f79b2bbcfb.jpg",
      features: ["현장 위험요인 파악", "개선대책 수립", "평가보고서 작성"]
    },
    {
      title: "근골격계유해요인조사",
      description: "근골격계 질환 예방을 위한 작업환경 조사 및 개선방안을 제시합니다.",
      image: "https://readdy.ai/api/search-image?query=Korean%20occupational%20health%20specialist%20evaluating%20workplace%20ergonomics%20with%20Korean%20office%20workers%2C%20ergonomic%20assessment%20in%20modern%20office%20environment%2C%20professional%20health%20consultant%20with%20measurement%20tools%2C%20bright%20office%20lighting%2C%20clean%20professional%20setting%2C%20corporate%20health%20and%20safety%20photography&width=800&height=600&seq=service-ergonomic-assessment-002&orientation=landscape",
      features: ["작업환경 분석", "유해요인 조사", "개선방안 제시"]
    },
    {
      title: "안전보건체계구축",
      description: "체계적인 안전보건관리 시스템을 구축하여 사업장의 안전문화를 정착시킵니다.",
      image: "https://readdy.ai/api/search-image?query=Korean%20business%20executives%20reviewing%20safety%20management%20system%20documents%20in%20modern%20conference%20room%2C%20professional%20safety%20system%20planning%20meeting%2C%20digital%20displays%20showing%20safety%20protocols%2C%20bright%20corporate%20office%2C%20professional%20business%20photography%20style%2C%20organized%20documentation&width=800&height=600&seq=service-safety-system-003&orientation=landscape",
      features: ["안전관리 체계 설계", "매뉴얼 작성", "교육 프로그램 구성"]
    },
    {
      title: "유해위험방지계획서",
      description: "건설공사 착공 전 필수 제출 서류로, 안전한 공사 진행을 위한 계획을 수립합니다.",
      image: "https://readdy.ai/api/search-image?query=Korean%20construction%20safety%20engineer%20reviewing%20hazard%20prevention%20plans%20at%20construction%20site%20office%2C%20safety%20blueprints%20and%20documents%20on%20desk%2C%20construction%20site%20visible%20through%20window%2C%20professional%20engineering%20consultation%2C%20bright%20office%20environment%2C%20realistic%20corporate%20photography&width=800&height=600&seq=service-hazard-prevention-004&orientation=landscape",
      features: ["공사 안전계획 수립", "법정 서류 작성", "인허가 지원"]
    },
    {
      title: "안전관리 위탁(대행)",
      description: "전문 안전관리자가 귀사의 안전관리 업무를 전담하여 수행합니다.",
      image: "https://readdy.ai/api/search-image?query=Professional%20Korean%20safety%20manager%20conducting%20workplace%20safety%20inspection%20with%20tablet%20and%20safety%20equipment%2C%20modern%20industrial%20workplace%2C%20safety%20consultant%20in%20professional%20attire%20with%20safety%20vest%2C%20bright%20industrial%20lighting%2C%20clean%20organized%20facility%2C%20corporate%20safety%20management%20photography&width=800&height=600&seq=service-safety-outsourcing-005&orientation=landscape",
      features: ["전문 안전관리자 배치", "정기 안전점검", "법규 준수 관리"]
    },
    {
      title: "KCs인증",
      description: "국가통합인증마크 취득을 위한 전 과정을 지원합니다.",
      image: "https://readdy.ai/api/search-image?query=Korean%20quality%20assurance%20specialist%20reviewing%20KCs%20certification%20documents%20in%20modern%20testing%20laboratory%2C%20professional%20certification%20process%2C%20quality%20control%20equipment%20in%20background%2C%20bright%20laboratory%20lighting%2C%20clean%20professional%20environment%2C%20corporate%20certification%20photography&width=800&height=600&seq=service-kcs-certification-007&orientation=landscape",
      features: ["인증 절차 안내", "시험 준비 지원", "사후관리"]
    }
  ];

  const totalSlides = services.length;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % totalSlides);
    }, 3500);

    return () => clearInterval(timer);
  }, [totalSlides]);

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % totalSlides);
  };

  return (
    <>
      <section id="services" className="py-12 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-extrabold bg-gradient-to-r from-blue-600 via-cyan-600 to-blue-600 bg-clip-text text-transparent mb-3 md:mb-4">
              전문 컨설팅 서비스
            </h2>
            <p className="text-base md:text-xl text-gray-600 font-medium">
              사업장 안전을 위한 모든 솔루션을 제공합니다
            </p>
          </div>

          {/* 서비스 탭 네비게이션 */}
          <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-8 md:mb-12 px-2">
            {services.map((service, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`px-4 md:px-6 py-2 md:py-3 rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer text-sm md:text-base ${
                  index === currentIndex
                    ? 'bg-blue-600 text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {service.title}
              </button>
            ))}
          </div>

          <div className="relative">
            {/* 갤러리 컨테이너 */}
            <div className="overflow-hidden">
              <div 
                className="flex transition-transform duration-700 ease-in-out"
                style={{ 
                  transform: isMobile 
                    ? `translateX(-${currentIndex * 100}%)` 
                    : `translateX(-${currentIndex * (100 / 3)}%)` 
                }}
              >
                {services.map((service, index) => (
                  <div
                    key={index}
                    className="min-w-full md:min-w-[33.333%] px-2 md:px-4"
                  >
                    <div className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                      <div className="w-full h-40 md:h-48 overflow-hidden">
                        <img 
                          src={service.image}
                          alt={service.title}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                      <div className="p-6 md:p-8">
                        <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">{service.title}</h3>
                        <p className="text-gray-600 mb-4 md:mb-6 leading-relaxed text-sm md:text-base">{service.description}</p>
                        <button
                          onClick={() => setIsModalOpen(true)}
                          className="w-full bg-blue-600 text-white py-2.5 md:py-3 rounded-lg font-bold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer text-sm md:text-base"
                        >
                          무료 견적받기
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* 좌우 화살표 버튼 */}
            <button
              onClick={goToPrevious}
              className="absolute left-0 md:left-0 top-1/2 -translate-y-1/2 -translate-x-2 md:-translate-x-4 bg-white rounded-full p-2 md:p-3 shadow-lg hover:bg-gray-50 transition-colors cursor-pointer z-10"
              aria-label="이전"
            >
              <i className="ri-arrow-left-s-line text-xl md:text-2xl text-gray-700"></i>
            </button>
            <button
              onClick={goToNext}
              className="absolute right-0 md:right-0 top-1/2 -translate-y-1/2 translate-x-2 md:translate-x-4 bg-white rounded-full p-2 md:p-3 shadow-lg hover:bg-gray-50 transition-colors cursor-pointer z-10"
              aria-label="다음"
            >
              <i className="ri-arrow-right-s-line text-xl md:text-2xl text-gray-700"></i>
            </button>

            {/* 진행 상태 표시 점 */}
            <div className="flex justify-center gap-2 mt-6 md:mt-8">
              {services.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-2.5 h-2.5 md:w-3 md:h-3 rounded-full transition-all duration-300 cursor-pointer ${
                    index === currentIndex ? 'bg-blue-600 w-6 md:w-8' : 'bg-gray-300'
                  }`}
                  aria-label={`슬라이드 ${index + 1}`}
                />
              ))}
            </div>
          </div>

          <div className="mt-8 md:mt-12 text-center">
            <p className="text-gray-500 text-xs md:text-sm">
              * 컨설팅 가격은 업종, 규모에 따라 상이할 수 있습니다.
            </p>
          </div>
        </div>
      </section>

      <ConsultingFormModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}
